<div class="basic-rating">
  <img alt="cbw-img" class="basic-rating--img" src="./assets/images/index-banner.png" />
  <span>Basic Rating</span>
</div>
